import { getAssetUrl } from "@/utils/common";
import styles from "./index.module.scss";
import { useQueryEvents,  useQueryLandmark, useQueryPoetry } from "@/services/hooks";
import { Background } from "@shuwen/wenlv-web-activity-library";
import GlobalLoading from "@/components/GlobalLoading";
import { useStore } from "@/store";
import { useTransition, animated, useSpring } from "@react-spring/web";
import { PageMode, DigitalHumanMode } from "@/store/types";
import Home from "../Home";
import Silent from "../Silent";
import Event from "../Event";
import LandmarkPoetry from "../LandmarkPoetry";
import CharacterRoute from "../CharacterRoute";
import ThemeRoute from "../ThemeRoute";
import ModeSwitch from "@/components/ModeSwitch";
import DigitalHuman from "../DigitalHuman";
import HomePlaceDetail from "../Home/components/HomePlaceDetail";
import LandmarkPoetryDetail from "../LandmarkPoetry/components/LandmarkPoetryDetail";
// import ThemeRouteDetail from "../ThemeRoute/components/ThemeRouteDetail";
// import CharacterRouteDetail from "../CharacterRoute/components/CharacterRouteDetail";
import CharaterTimeLine from "../CharaterTimeLine";
import { useQueryGetPlaceJson } from "@/services/hooks";
import CharaterRouteVideo from "../CharaterRouteVideo";
import HomeBgVideo from "../Silent/HomeBgVideo";
import TransitioningVideo from "../Silent/TransitioningVideo";
import Title from "./Title";
import AudioPlayer from "./AudioPlayer";
import ThemeList from "../ThemeList";

export function App() {
  const { isLoading: landmarkLoading } = useQueryLandmark();
  const { isLoading: eventsLoading } = useQueryEvents();
  const { isLoading: poetryLoading } = useQueryPoetry();
  const { isLoading: placeLoading } = useQueryGetPlaceJson();
  // 关键数据加载期间显示全局 loading（诗词地标预热最慢，约 120s）
  const dataLoading = landmarkLoading || eventsLoading || poetryLoading || placeLoading;
  const mode = useStore((state) => state.mode);
  // const digitalHumanMode = useStore((state) => state.digitalHumanMode);

  // const pageSpring = useSpring({
  //   scale: digitalHumanMode === DigitalHumanMode.FULLSCREEN ? 1.2 : 1,
  //   config: {
  //     duration: 500
  //   }
  // });

  const transitions = useTransition(mode, {
    from: { opacity: 0, transform: 'scale(0.8)' },
    enter: { opacity: 1, transform: 'scale(1)' },
    leave: { opacity: 0, transform: 'scale(0.8)' },
    delay: mode === PageMode.SILENT ? 0 : 500,
    config: {
      tension: 300,
      friction: 20
    }
  });

  const renderPage = (mode: PageMode) => {
    switch (mode) {
      case PageMode.HOME:
        return <Home />;
      case PageMode.EVENT:
        return <Event />;
      case PageMode.LANDMARK_POETRY:
        return <LandmarkPoetry />;
      case PageMode.ROUTE_CHARACTER_LIST:
        return <CharacterRoute />;
      case PageMode.ROUTE_THEME_LIST:
        return <ThemeList />;
      case PageMode.ROUTE_CHARACTER_TRACK:
        return <CharaterRouteVideo />;
      case PageMode.ROUTE_CHARACTER_TRACK_SINGLE:
        return <ThemeRoute />;
      default:
        return <Silent />;
    }
  };

  return (
    <Background
      url={getAssetUrl("images/route/timeLine/timeLineBg.png")}
      className={styles.app}
    >
      <animated.div 
        className={styles.pageContainerWrapper}
        // style={pageSpring}
      >
        {/* <Background url={getAssetUrl('images/slient/homeBg.png')}  className={styles.app}> */}
        <HomeBgVideo />
        <Title />
        {transitions((style, item) => (
          <animated.div style={style} className={styles.pageContainer}>
            {renderPage(item)}
          </animated.div>
        ))}
        {/* </Background> */}
       
      </animated.div>
      {/* <LandmarkPoetryDetail /> */}
      <CharaterTimeLine />
      {/* <ThemeRouteDetail /> */}
      {/* <CharacterRouteDetail /> */}
      <TransitioningVideo />


      <ModeSwitch />
      {/* 数字人 */}
      <DigitalHuman />
      <AudioPlayer />
      <GlobalLoading
        visible={dataLoading}
        pending={{
          poetry: poetryLoading,
          landmark: landmarkLoading,
          events: eventsLoading,
          place: placeLoading,
        }}
      />
    </Background>
  );
}
